/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAPIError from '../../../hooks/useAPIError';
import { useAuthStore } from '../../../store/AuthContext';
import TarjetaService from '../../../services/TarjetaService';
import clubTarjeta from '../../../assets/images/club-tarjeta-caprabo.png';
import TarjetaTemporalSolicitarTarjeta from '../commons/TarjetaTemporalSolicitarTarjeta';
import TarjetaForm from './form/solicitudTarjetaForm';
import DataService from '../../../services/MisDatosService';
import { AddittionalPojo } from '../../../types/PersonalData';
import { CryptoUtil } from '../../../utils/CryptoUtil';

interface Props {
  cardNumberLong: string | undefined;
  cardNumberShort: string | undefined;
  controlDigit: string | undefined;
  load: boolean;
}
const TitularCaprabo: FC<Props> = (props) => {
  const { t } = useTranslation();
  const dataUser = useAuthStore();
  const { cardNumberLong, cardNumberShort, controlDigit, load } = props;
  const [showModalAdicionalForm, setShowModalAdicionalForm] = useState<boolean>(
    false,
  );
  const { addError, addErrorBack } = useAPIError();
  const [additionalData, setAddittionalData] = useState<AddittionalPojo[]>([]);

  const getTipoDoc = (tipoDocumento: string) => {
    if (tipoDocumento === '1') return 'NIF';
    if (tipoDocumento === '2') return 'Pasaporte';
    if (tipoDocumento === '3') return 'NIE';
    if (tipoDocumento === '4') return 'CIF';
    return 'OTROS';
  };

  const getInfoAdicionales = (doc: any, tipoDoc: any) => {
    const numeroTarjeta =
      cardNumberShort && controlDigit ? cardNumberShort + controlDigit : '';
    const numeroDocumento = CryptoUtil.decryptAes(doc);
    const tipoDocumento = getTipoDoc(CryptoUtil.decryptAes(tipoDoc));
    if (numeroTarjeta !== '') {
      const data = {
        cardNumberLong: btoa(CryptoUtil.encryptAes(numeroTarjeta)),
        documento: btoa(CryptoUtil.encryptAes(numeroDocumento)),
        tipoDocumento: btoa(CryptoUtil.encryptAes(tipoDocumento)),
      };
      TarjetaService.getAdicionalesInfo(data)
        .then((response) => {
          if (response.data.error) {
            addErrorBack(response.data);
          } else if (response.data && response.data.pojos) {
            setAddittionalData(response.data.pojos);
          }
        })
        .catch((e) => {
          console.log(e);
          addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
        });
    }
  };

  const getPersonalData = () => {
    const isReqwiredNumDoc = true;
    DataService.personalData(isReqwiredNumDoc)
      .then((response) => {
        if (response.data.error === true) {
          addErrorBack(response.data);
        } else if (response.data && response.data.pojo) {
          const { idDocumento, tipoDocumento } = response.data.pojo;
          getInfoAdicionales(idDocumento, tipoDocumento);
        }
      })
      .catch(() => {
        addError(t('nlr-vaya-algo-no-ha-ido-bien'), 'KO');
      });
  };

  useEffect(() => {
    if (dataUser.user.token !== '') {
      getPersonalData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {(() => {
        if (load) {
          return (
            <>
              {' '}
              <section className="section header-tarjetas tarjetas">
                <div className="container">
                  <div className="header-tarjetas__content">
                    <h1 className="header-tarjetas__title">
                      {t('tarjetas.tarjeta-socio.title')}
                    </h1>
                    <p>
                      {t('caprabo.tarjetas.tarjeta-socio.partner-card')}{' '}
                      <strong>{cardNumberLong}</strong>
                    </p>
                  </div>
                </div>
              </section>
              <section className="o-section--giant__top u-padding-bottom-hero section--background-color tarjetas">
                <div className="container-inner">
                  <div className="img-tarjeta">
                    <img src={clubTarjeta} alt="Tarjeta Club Caprabo" />
                  </div>

                  <div className="tarjeta__content">
                    <h2 className="bloque-datos__title">
                      <span className="divider__square brand-color" />
                      <span className="u-margin-right">
                        {t('tarjetas.tarjeta-socio.caprabo-club')}
                      </span>
                    </h2>
                    <TarjetaTemporalSolicitarTarjeta
                      showModalAdicionalForm={showModalAdicionalForm}
                      setShowModalAdicionalForm={setShowModalAdicionalForm}
                      additionalData={additionalData}
                    />
                  </div>
                </div>
              </section>
              <TarjetaForm
                visible={showModalAdicionalForm}
                setVisible={setShowModalAdicionalForm}
              />
            </>
          );
        }
        return false;
      })()}
    </>
  );
};

export default TitularCaprabo;
